import PropTypes from 'prop-types';
import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import Helmet from 'react-helmet';
import {withTranslation} from 'react-i18next';
import logoCleanbill from '../../common/assets/img/logo-cleanbill-blanc.png';
import Copyright from '../../common/components/layout/Copyright';
import LoginButton from '../../common/components/LoginButton';
import {Card, CardGroup, CardText, CardTitle} from '../../common/look';
import LoginForm from './LoginForm';
import config from '../../config/app';

const renderMetaData = t => (
  <Helmet
    title={`${config.name} - ${t('login.title')}`}
    meta={[
      {
        name: 'description',
        content: `${config.name} - ${t('login.meta')}`,
      },
    ]}
  />
);

const LoginView = ({t, isRegistered, hideModal, history}) => {

  const renderConfirmationModal = () => (
    <Card className="confirm-email">
      <CardGroup style={{textAlign: 'center'}}>
        <CardTitle>{t('reg.successRegTitle')}</CardTitle>
        <CardText>{t('reg.successRegBody')}</CardText>
        <CardText>
          <LoginButton onClick={hideModal}>
            {t('login.form.title')}
          </LoginButton>
        </CardText>
      </CardGroup>
    </Card>
  );

  return (
    <Container className="container-full login-container">
      {renderMetaData(t)}
      {isRegistered ? (
        renderConfirmationModal()
      ) : (
        <React.Fragment>
          <Row>
            <Col xs={{span: 6, offset: 3}} lg={{span: 4, offset: 4}} className="cleanbill-login-col">
              <img src={logoCleanbill} className="cleanbill-white-logo" alt="logo" />
            </Col>
          </Row>
          <LoginForm history={history}/>
        </React.Fragment>
      )}
      <Row>
        <Col xs={12} className="white-centered copyright">
          <Copyright/>
        </Col>
      </Row>
    </Container>
  );
};

LoginView.propTypes = {
  t: PropTypes.func,
  isRegistered: PropTypes.bool,
  hideModal: PropTypes.func,
  history: PropTypes.object,

};

export default withTranslation('login')(LoginView);
